import React from 'react';
import { products } from '../data/products';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';
import ProductCard from './ProductCard';

function TowelDryers({ onProductClick }) {
  const { t } = useLanguage();

  return (
    <section className="towel-dryers">
      <div className="container">
        <h2 className="section-title">{t(translations.towelDryers.title)}</h2>
        <p className="section-subtitle">
          {t(translations.towelDryers.subtitle)}
        </p>

        <div className="products-grid">
          {products.towelDryers.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onClick={onProductClick}
            />
          ))}
        </div>

        <div className="extra-products">
          <h3>{t(translations.towelDryers.shoeDryersTitle)}</h3>
          <div className="products-grid">
            {products.shoeDryers.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onClick={onProductClick}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TowelDryers;
